import { useEffect, useState } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import axiosInstance from '../axiosInstance';

import "../css/template_custom.css";
import "../css/template_menu.css";
import "../libs/menu_js.js";
import '../libs/templates.js';
import '../libs/comments.js';
import "../libs/site_js.js";
import '../libs/lib-filter/lib-filter.css';
import '../libs/lib-filter/lib-filter.js';
import '../libs/form-validation.js';
import "../css/site_css.css";
import "../css/comunity.css";
import PrivateRoute from "../PrivateRoute";
import BackendHeader from '../component/BackendHeader';
import * as general from '../libs/general';

const AdminLayout = ({ children, roles = ['admin'] }) => {
  const currentUser = useSelector((state) => state.user.user);
  const [effectiveFlags, setEffectiveFlags] = useState({
    isAdmin: currentUser?.isAdmin === true,
    isMember: currentUser?.isMember === true,
  });
  const location = useLocation();
  const getClassActive = (source) => {
    var list = source.split('/');
    const pagePath = location.pathname.replace(/^\/|\/$/g, '');

    if (list.includes(pagePath)) return 'active';
    if (list.includes(pagePath + location.search)) return 'active';
    return '';
  };

  useEffect(() => {
    const handleEvent = () => { window.configLoaded = false; loadDataConfig(); };
    window.addEventListener('load-data-config', handleEvent);
    return () => { window.removeEventListener('load-data-config', handleEvent); };
  }, []);

  useEffect(() => {
    var menuClass = sessionStorage.getItem('menu_class');
    if (!menuClass) menuClass = 'nav-md';
    document.body.classList.add(menuClass);

    loadDataConfig();
  }, []);

  useEffect(() => {
    setEffectiveFlags({
      isAdmin: currentUser?.isAdmin === true,
      isMember: currentUser?.isMember === true,
    });
  }, [currentUser?.isAdmin, currentUser?.isMember]);

  useEffect(() => {
    let mounted = true;
    axiosInstance.get("/api/users/my-flags")
      .then((res) => {
        if (!mounted) return;
        const flags = res?.data?.data || {};
        setEffectiveFlags({
          isAdmin: flags.isAdmin === true,
          isMember: flags.isMember === true,
        });
      })
      .catch(() => {
        // keep local redux flags if endpoint unavailable
      });
    return () => {
      mounted = false;
    };
  }, []);
  const loadDataConfig = async () => {
    if (window.configLoaded) return;

    var requestApi = `/api/users/getConfig`;
    try {
      if (window.callingApi) return;
      window.callingApi = true;
      var response = await axiosInstance.get(requestApi);
      general.setLocalStorage("user_config", response.data.data);
      window.configLoaded = true;
      window.dispatchEvent(new Event("user-config-loaded"));

    } catch (error) {
      console.error(error);
    } finally {
      window.callingApi = false;
    }
  }

  const canAccessAdminLayout = effectiveFlags.isAdmin === true || effectiveFlags.isMember === true;
  if (!canAccessAdminLayout) {
    return <Navigate to="/trang-chu" replace />;
  }

  return (
    <div className="web-cover-admin">
      <PrivateRoute roles={roles}>
        <BackendHeader />
        <div className="web-main relative">
          <div className="container body main_container">
            <div className="col-md-3 left_col">

              <div className="left_col scroll-view menu_oha">
                <div className="navbar nav_title">
                  <Link className="site_title" to="/dashboard"><i className="fa fa-life-ring"></i> <span>ZTO</span></Link>
                </div>
                <div className="clearfix"></div>
                <div className="profile clearfix">
                  <div className="profile_pic">
                    <img src="https://img.freepik.com/premium-vector/account-icon-user-icon-vector-graphics_292645-552.jpg" alt="..." className="img-circle profile_img" />
                  </div>
                  <div className="profile_info">
                    <span>Welcome,</span>
                    <h2>ztovietnam</h2>
                  </div>
                </div>
                <br />
                <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
                  <div className="menu_section">
                    <ul className="nav side-menu">
                      {/* <li className={getClassActive('/dashboard/customers')}><a><i className="fa fa-home"></i> Home <span className="fa fa-chevron-down"></span></a>
                        <ul className="nav child_menu">
                          <li className={getClassActive('/dashboard')}><Link to="/dashboard">Welcome</Link></li>
                          <li className={getClassActive('/customers')}><Link to="/customers">Khách hàng</Link></li>
                        </ul>
                      </li> */}
                      <li className={getClassActive('/setting/setting-progress/order-setting/ranking-setting/joblogs')}><a><i className="fa fa-table"></i>Thiết lập đơn hàng</a>
                        <ul className="nav child_menu">
                          <li className={getClassActive('/setting?key=1')}><Link to="/setting?key=1">Lines</Link></li>
                          <li className={getClassActive('/setting?key=2')}><Link to="/setting?key=2">Đơn vị tính</Link></li>
                          <li className={getClassActive('/setting-progress')}><Link to="/setting-progress">Lưu trình</Link></li>
                          <li className={getClassActive('/setting?key=4')}><Link to="/setting?key=4">Đối soát</Link></li>
                          <li className={getClassActive('/order-setting')}><Link to="/order-setting">Cài đặt đơn hàng</Link></li>
                          <li className={getClassActive('/ranking-setting')}><Link to="/ranking-setting">Cài đặt xếp hạng</Link></li>
                          <li className={getClassActive('/joblogs')}><Link to="/joblogs">Lịch sử chạy jobs</Link></li>

                        </ul>
                      </li>
                      <li className="d-none"><a><i className="fa fa-bug"></i> Additional Pages <span className="fa fa-chevron-down"></span></a>
                        <ul className="nav child_menu">
                          <li className=""><a href="list_contacts.html">Contacts</a></li>
                          <li><a href="profile.html">Profile</a></li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="sidebar-footer hidden-small d-none">
                  <a data-toggle="tooltip" data-placement="top" title="Settings">
                    <span className="glyphicon glyphicon-cog" aria-hidden="true"></span>
                  </a>
                  <a data-toggle="tooltip" data-placement="top" title="FullScreen">
                    <span className="glyphicon glyphicon-fullscreen" aria-hidden="true"></span>
                  </a>
                  <a data-toggle="tooltip" data-placement="top" title="Lock">
                    <span className="glyphicon glyphicon-eye-close" aria-hidden="true"></span>
                  </a>
                  <a data-toggle="tooltip" data-placement="top" title="Logout" href="login.html">
                    <span className="glyphicon glyphicon-off" aria-hidden="true"></span>
                  </a>
                </div>

              </div>
            </div>

            {children}
          </div>
        </div>
      </PrivateRoute>
    </div>
  );
};

export default AdminLayout;
